















import { Component, Prop, Vue } from 'vue-property-decorator'
import __ from '@/shared/helpers/__'
import PageHeader from '@/admin/components/PageHeader.vue'
import Form from '@/shared/components/form/Form.vue'
import FormBase from '@/shared/classes/form/form-base'
import { GlobalActions } from '@/shared/store/global/global.actions'
import Field, { FieldSizes } from '@/shared/classes/form/field'
import { HttpMethod } from '@/shared/helpers/requests.helper'
import InstructionCategory from '@/shared/modules/instruction-categories/instruction-category.model'

@Component({
  components: { Form, PageHeader },
  methods: { __ },
})
export default class CreateInstructionCategoriesDialog extends Vue {
  @Prop() meta!: any
  form: FormBase | null = null
  loading: boolean = false

  created() {
    let fields = [
      new Field()
        .setKey('name')
        .setSize(FieldSizes.full)
        .isRequired()
        .setTranslatable(true)
        .setTitle(__('admin.components.instruction-categories.create-dialog.form.name')),
    ]

    this.form = new FormBase()
      .setEndpoint(`instruction-categories`)
      .setTranslatable(true)
      .setMethod(HttpMethod.POST)
      .setModel(InstructionCategory)
      .setValidate(true, { onlyRegionLangRequired: true })
      .setFields(fields)
      .setOnSuccess(this.meta.onSuccess)
  }

  async closeDialog() {
    await this.$store.dispatch(GlobalActions.closeDialog)
  }
}
